import React, { useState } from 'react';
import './Blog.css';

const videos = [
  { id: 'nym68zWPtwA' },
  { id: 'o_g585Q5-Wg' },
  { id: 'AW_LbmFcoCM' },
];

const Blog = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  return (
    <section className="blog container section" id="blog">
      <h2 className="section__title">Latest Videos</h2>

      <div className="blog__container">
        {videos.map(video => (
          <div className="blog__card" key={video.id}>
            <div className="blog__thumb">
              {activeVideo === video.id ? (
                <iframe
                  className="video__embed"
                  src={`https://www.youtube.com/embed/${video.id}?autoplay=1`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                />
              ) : (
                <img
                  onClick={() => setActiveVideo(video.id)}
                  src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                  alt="Video thumbnail"
                  className="blog__img"
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Blog;
